export default{
    title: "Plataforma do Cliente",
    welcome: "Bem-vindo",
    acsess: 'Acessar minha conta',
    passowrd: 'Senha',
    sign_in: 'Acessar',
    invite_text: 'Ainda não e cliente Stonebox? Visita a nossa plataforma e tenha acesso a todo nosso estoque de blocos',
    btn_invite: 'Acessar agora'
}